export function actionBuryPointWay (web_site, page_no, action, more_info) { // 网站名称 |  页面的ID | 操作的名称  |  更多的信息，做成string上传  
  let that = this
    // console.log(web_site, page_no, action, more_info);
    let data = {web_site:'sky-code-web' + web_site,page_no:page_no, action:action, more_info:more_info }
    // console.log(data);
    that.$jsonPost(that.$axiosUrl.actionLog, data)
        .then((response) => {
          console.log(response)
        }).catch(()=>{})
}